import { app } from '../app';
import { SpConstantAlert } from '../components/sp-constant-alert/sp-constant-alert.model';

app.service('ConstantAlert', ConstantAlert);

/** @ngInject */
function ConstantAlert($rootScope) {
    return (...args) => $rootScope.globalTopLevelLicenseMessage = new SpConstantAlert(...args);
}


// WEBPACK FOOTER //
// ./src/portal/services/constant-alert.service.js